module.exports = __webpack_public_path__ + "static/media/8OLA28.c6a7de37.jpg";